
namespace Matrix.Indexation {
    export class IndexationProfileColumns {
        static columnsKey = 'Indexation.IndexationProfile';
    }
}